import { inject, Injectable } from '@angular/core';
import { StorageKeyName, StorageService } from './storage.service';
import { ApiService } from './api.service';
import { BehaviorSubject, from, Observable } from 'rxjs';


/**
 *  Reloads the browser cache if the user has a old frontend version 
 *  (window.location.reload()).
 * 
 *  @description
 *  Checks the version of the app by calling and endpoint.
 *  The endpoint to call is defeined in CoreConfiguration
 * 
 * @example
 * By default, the 'entry-point-service' calls the checkvrsion function.
 * 
 * Example implementation:
 * ```ts
 * constructor(private checkV : CheckVersionService) {
 *  this.checkV.checkVersion();
 * }
 * ```
 */

@Injectable({
  providedIn: 'root'
})
export class CheckVersionService {

  private versionSubject = new BehaviorSubject<string>('--');
  version$: Observable<string> = this.versionSubject.asObservable();
  version : string = "--";

  storageS: StorageService = inject(StorageService);
  apiS: ApiService = inject(ApiService);

  checkVersion() : Observable<string> {
    // Devolvemos observable de la promesa de chequear version al backend.
    return from(this.checkVersionAsync());
  }

  // Método async original (privado)
  private async checkVersionAsync(): Promise<string> {
    try {
      const current = await this.apiS.noauth.checkVersion();
      const saved = this.storageS.get(StorageKeyName.EINA_VERSION_KEY);

      if (saved == null) {
        this.storageS.save(StorageKeyName.EINA_VERSION_KEY, current);
      } else if (current != saved) {
        this.storageS.save(StorageKeyName.EINA_VERSION_KEY, current);
        console.log("Changing version!");
        setTimeout(() => this.refresh(), 100);
      }

      // Actualizar el BehaviorSubject
      this.versionSubject.next(current);
      return current;
      
    } catch (error) {
      console.error('Error checking version:', error);
      this.versionSubject.next('--');
      return '--';
    }
  }

  refresh() {
    window.location.reload()
  }

}